import { Link } from 'react-router-dom';

interface ClusterCard {
  title: string;
  description: string;
  to?: string;
  available: boolean;
}

const clusterCards: ClusterCard[] = [
  {
    title: 'Тренинг для руководителей',
    description: 'Практическая программа развития управленческих компетенций: от постановки задач до управления изменениями. Для руководителей всех уровней.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    available: true,
  },
  {
    title: 'Лидерство и управленческое влияние',
    description: 'Как руководителю влиять на команду, формировать доверие и добиваться результата не только за счёт должностных полномочий.',
    to: '/menedzhment-i-liderstvo/trening-po-liderstvu',
    available: true,
  },
  {
    title: 'Делегирование и постановка задач',
    description: 'Как передавать ответственность сотрудникам и сохранять контроль над результатом без микроменеджмента.',
    to: '/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach',
    available: true,
  },
  {
    title: 'Обратная связь и сложные разговоры',
    description: 'Как давать обратную связь, которая меняет поведение сотрудника, и проводить сложные управленческие разговоры.',
    to: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
    available: true,
  },
  {
    title: 'Мотивация и управление командой',
    description: 'Как понимать мотивацию сотрудников и создавать условия для высокой вовлечённости и результативности.',
    to: '/menedzhment-i-liderstvo/motivatsiya-i-upravlenie-komandoy',
    available: true,
  },
  {
    title: 'Управление конфликтами',
    description: 'Как разбирать конфликты между сотрудниками, подразделениями и руководителями, превращая их в рабочие решения.',
    to: '/menedzhment-i-liderstvo/trening-po-upravleniyu-konfliktami',
    available: true,
  },
  {
    title: 'Управленческие переговоры',
    description: 'Как руководителю вести сложные переговоры с сотрудниками, коллегами, собственниками и руководством.',
    to: '/menedzhment-i-liderstvo/upravlencheskie-peregovory',
    available: true,
  },
  {
    title: 'Руководитель в переговорах',
    description: 'Как руководителю влиять, договариваться и отстаивать интересы бизнеса в переговорах с сотрудниками, руководством, клиентами и партнёрами.',
    to: '/menedzhment-i-liderstvo/rukovoditel-v-peregovorah',
    available: true,
  },
  {
    title: 'Управление изменениями',
    description: 'Как внедрять новые процессы и изменения, работая с сопротивлением команды и достигая запланированных результатов.',
    to: '/menedzhment-i-liderstvo/upravlenie-izmeneniyami',
    available: true,
  },
  {
    title: 'Развитие управленческих компетенций',
    description: 'Комплексная оценка и развитие ключевых управленческих навыков для повышения эффективности руководителей.',
    to: '/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy',
    available: true,
  },
  {
    title: 'Наставничество и развитие сотрудников',
    description: 'Как формировать кадровый резерв, развивать сильных специалистов и выращивать будущих руководителей.',
    to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov',
    available: true,
  },
];

export default function ClusterNavigation() {
  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Обучение менеджменту и лидерству
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          У компаний могут быть разные управленческие задачи, поэтому существуют отдельные программы. Выберите направление, которое наиболее актуально для вашей управленческой команды.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {clusterCards.map((card, i) => (
            <div key={i} className={`bg-white rounded-xl border ${card.available ? 'border-gray-200 hover:border-teal-300 hover:shadow-lg' : 'border-gray-200/70'} transition-all p-5 md:p-6 flex flex-col`}>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{card.description}</p>
              {card.available && card.to ? (
                <Link to={card.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto">
                  Подробнее
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-sm text-gray-400 mt-auto">
                  Скоро
                  <i className="ri-time-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}